import React, { useState, useRef } from "react";
import { Button } from "@chakra-ui/react";
import "../../Animations.css";
import { haptic } from "@/lib/haptic";

interface ContinueButtonProps {
  onClick: () => void;
  text?: string;
  disabled?: boolean;
  className?: string;
  backgroundColor?: string;
  textColor?: string;
  outlineColor?: string;
}

const ContinueButton: React.FC<ContinueButtonProps> = ({
  onClick,
  text,
  disabled,
  backgroundColor = "var(--color-blue)",
  textColor = "white",
  className,
  outlineColor,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const wasDisabledAtClick = useRef(false);

  const handleClick = () => {
    if (disabled || isAnimating) {
      return;
    }
    haptic.soft();
    setIsAnimating(true);
    wasDisabledAtClick.current = !!disabled;
    setTimeout(() => {
      setIsAnimating(false);
      if (!wasDisabledAtClick.current) {
        onClick();
      }
    }, 300);
  };

  return (
    <Button
      variant="default"
      onClick={handleClick}
      bg={disabled ? "var(--color-grey-light)" : backgroundColor}
      isDisabled={disabled}
      rounded={"xl"}
      color={textColor}
      height={"var(--button-height)"}
      fontSize="base"
      border={outlineColor ? `1px solid ${outlineColor}` : "none"}
      className={`w-full text-center items-center justify-center self-center font-bold break-words flex-shrink-0 ${className} ${
        isAnimating ? "press-animation" : ""
      }`}
      _disabled={{
        bg: "var(--color-grey-light)",
        color: textColor,
        opacity: 1, // optional: keep full opacity
        cursor: "not-allowed",
        _hover: { bg: "var(--color-grey-light)" }, // beats :hover:disabled rule
        _active: { bg: "var(--color-grey-light)" }, // just in case
      }}
    >
      {text || "Continue 🏃‍♂️"}
    </Button>
  );
};

export default ContinueButton;
